import React from "react";
import "./FormInput.css";

const FormInput = (props) => {
  const {
    type,
    label,
    name,
    value,
    onChange,
    placeholder,
    className = "",
    rows,
    ...rest
  } = props;

  return (
    <div className="form-group mb-3">
      {label && (
        <label htmlFor={name} className="form-label fw-semibold">
          {label}
        </label>
      )}

      {type === "textarea" ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={`form-control soft-input ${className}`}
          {...rest}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`form-control soft-input ${className}`}
          {...rest}
        />
      )}
    </div>
  );
};

export default FormInput;
